import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function moveLeadToPurchaser(leadId, userType) {
	var uid = firebase.auth().currentUser.uid;
	await firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + leadId)
		.once('value', async (snapshot) => {
			var leadData = snapshot.val();
			var salesAgentId =
				snapshot.val().leadToSalesAgent || snapshot.val().salesAgent;

			console.log('moveLeadToPurchaser', leadData);

			console.log('salesAgentId', salesAgentId);

			await firebaseRef
				.ref(
					'/kavtek_purchasers/' +
						PROJECT_CODE.projectCode +
						'/' +
						salesAgentId
				)
				.update({ [leadId]: leadData });

			await firebaseRef
				.ref(
					'/kavtek_purchasers/' +
						PROJECT_CODE.projectCode +
						'/' +
						salesAgentId +
						'/' +
						leadId
				)
				.update({
					leadId: leadId,
					leadToSalesAgent: salesAgentId,
					createTimestamp: new Date(),
				});

			if (userType === 'cobroker') {
				await firebaseRef
					.ref(
						'/kavtek_purchasers/' +
							PROJECT_CODE.projectCode +
							'/' +
							salesAgentId +
							'/' +
							leadId
					)
					.update({
						cobroker: uid,
					});
			}
			leadData['leadId'] = leadId;
			await firebaseRef
				.ref(
					'/kavtek_agreements/' +
						PROJECT_CODE.projectCode +
						'/' +
						leadId
				)
				.update({ leadDetails: leadData });

			// Update kavte_agreements/project/leadId/clientInfo/individual/push
			let generateRefKey = await firebaseRef
				.ref(
					'/kavtek_agreements/' +
						PROJECT_CODE.projectCode +
						'/' +
						leadId +
						'/clientInfo/individual'
				)
				.push();
			let uidAgreementRef = generateRefKey.key;
			await firebaseRef
				.ref(
					'/kavtek_agreements/' +
						PROJECT_CODE.projectCode +
						'/' +
						leadId +
						'/clientInfo/individual/0'
				)
				.update({
					firstName: leadData?.clientFName || '',
					lastName: leadData?.clientLName || '',
					email: leadData?.clientEmail || '',
					occupation: '',
					phoneNumber: leadData?.clientPhoneNumber || '',
					address1: '',
					address2: '',
					city: '',
					province: '',
					postalCode: '',
					isPrimary: true,
					id: uidAgreementRef,
					identification: leadData?.identification || null,
				});
		});

	// @TODO: UNCOMMENT
	await firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
		.child(leadId)
		.remove();
}
